export default __webpack_public_path__ + "static/media/calendar.dc5b6f15.svg";